import { render, staticRenderFns } from "./ButtonWpp.vue?vue&type=template&id=04284d15&scoped=true"
import script from "./ButtonWpp.vue?vue&type=script&lang=js"
export * from "./ButtonWpp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04284d15",
  null
  
)

export default component.exports